import { FormatType } from '@/shared/hooks';

export enum MetricColumnDataType {
  NUMBER = 'number',
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}

export enum DimensionColumnDataType {
  DATE = 'date',
  TEXT = 'text',
  URL = 'url',
  MEDIA = 'media',
}

export type ColumnDataType = DimensionColumnDataType | MetricColumnDataType;

export enum ColumnType {
  DIMENSION = 'dimension',
  METRIC = 'metric',
}

export enum DimensionDataFormatType {
  DATE = 'date',
  STRING = 'string',
}

export enum MetricDataFormatType {
  INTEGER = 'integer',
  NUMERIC = 'numeric(18,2)',
  NUMERIC_4 = 'numeric(18,4)',
}

export type ColumnDataFormatType =
  | DimensionDataFormatType
  | MetricDataFormatType;

interface ColumnBaseConfig {
  group: string;
  name: string;
  description: string;
  order: number;
  isAdvancedSortable: boolean;
}
type MetricColumn = ColumnBaseConfig & {
  type: MetricColumnDataType;
  dataType: MetricDataFormatType;
};

type DimensionColumn = ColumnBaseConfig & {
  type: DimensionColumnDataType;
  dataType: DimensionDataFormatType;
};

export type ColumnsConfig = Record<string, MetricColumn | DimensionColumn>;

export interface ColumnsMeta {
  defaultColumns: {
    dimensions: string[];
    metrics: string[];
  };
  config: ColumnsConfig;
  dimensions: string[];
  metrics: string[];
}

export const toFormatType = (type: MetricDataFormatType): FormatType => {
  switch (type) {
    case MetricDataFormatType.INTEGER:
      return FormatType.INTEGER;
    case MetricDataFormatType.NUMERIC:
      return FormatType.FLOAT;
    case MetricDataFormatType.NUMERIC_4:
      return FormatType.FLOAT_4;
    default:
      console.warn(`Unexpected type: ${type}. Fallback to FLOAT4.`);
      return FormatType.FLOAT_4;
  }
};

export const isMediaDimension = (
  config: Record<
    string,
    { type: DimensionColumnDataType | MetricColumnDataType }
  >,
  dimensionId: string,
): boolean => config[dimensionId]?.type === DimensionColumnDataType.MEDIA;

export const isDateDimension = (
  config: Record<
    string,
    { type: DimensionColumnDataType | MetricColumnDataType }
  >,
  dimensionId: string,
): boolean => config[dimensionId]?.type === DimensionColumnDataType.DATE;
